var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiplechoiceExamEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 184,
    viewBox: "0 0 216 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_63575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9766 88.4043C19.9766 100.026 22.2657 111.534 26.7132 122.272C31.1608 133.009 37.6796 142.765 45.8976 150.983C54.1156 159.201 63.8718 165.72 74.6091 170.168C85.3464 174.615 96.8546 176.904 108.477 176.904L108.477 88.4043L19.9766 88.4043Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.555,
    cy: 88.5711,
    r: 76.4734,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 106.72C118.515 106.72 126.639 98.5942 126.639 88.5701C126.639 78.546 118.515 70.4199 108.493 70.4199C98.4718 70.4199 90.3477 78.546 90.3477 88.5701C90.3477 98.5942 98.4718 106.72 108.493 106.72Z",
    fill: "#90B1FB",
    stroke: "#187E8A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 100.685C115.183 100.685 120.606 95.2612 120.606 88.5702C120.606 81.8792 115.183 76.4551 108.493 76.4551C101.804 76.4551 96.3813 81.8792 96.3813 88.5702C96.3813 95.2612 101.804 100.685 108.493 100.685Z",
    fill: "white",
    stroke: "#187E8A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 118.834C125.204 118.834 138.751 105.284 138.751 88.569C138.751 71.854 125.204 58.3037 108.493 58.3037C91.7825 58.3037 78.2356 71.854 78.2356 88.569C78.2356 105.284 91.7825 118.834 108.493 118.834Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 136.985C135.226 136.985 156.897 115.309 156.897 88.5698C156.897 61.8307 135.226 40.1543 108.493 40.1543C81.7609 40.1543 60.0898 61.8307 60.0898 88.5698C60.0898 115.309 81.7609 136.985 108.493 136.985Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.071 88.5693H44.9609",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 152.118V24.9766",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.628 88.4346L129.791 110.098",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.847 88.57C147.847 66.8168 130.241 49.207 108.493 49.207",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.969 39.7241L146.563 45.9013L158.791 42.8593L164.104 36.7568L151.969 39.7241Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.321 27.4079L152.322 38.9043L162.723 27.4079L164.065 14.9043L153.321 27.4079Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.224 75.9864L162.724 27.4453",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.896 24.3662L158.791 42.8613L146.563 45.9023L162.724 27.4464L174.896 24.3662Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.066 14.9043L148.036 33.4544L146.563 45.9021L162.724 27.4079L164.066 14.9043Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.467 33.4361L169.62 30.4502",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.969 39.7244L153.311 27.3701",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.867 83.2828L118.49 68.9316L120.224 75.9859L127.027 76.3405L113.867 83.2828Z",
    fill: "#2F68E9",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_63575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 184,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplechoiceExamEnd);
export default __webpack_public_path__ + "static/media/multiplechoice_exam_end.f204df00275ad546a549b808de639a7e.svg";
export { ForwardRef as ReactComponent };